export enum EFileType {
  JPG = 'jpg',
  JPEG = 'jpeg',
  PNG = 'png',
  PDF = 'PDF',
  XLSX = 'xlsx',
}
